import React from 'react';
import { bonuses } from '../data/breakFreeContent';
export function BonusesSection() {
  return <section className="w-full bg-charcoal-900 py-12 sm:py-16" aria-labelledby="bonuses-title" data-id="element-17" data-mp="gw5dg2n31rsq">
      <div className="mx-auto max-w-5xl px-5" data-id="element-18" data-mp="vtxn4e5y7lz0">
        <h2 id="bonuses-title" className="text-center font-display text-[1.6rem] font-semibold uppercase leading-tight text-ivory-50 sm:text-[2.25rem]" data-id="element-19" data-mp="vqjlj853zgsm">
          6 Exclusive bonuses
        </h2>

        <ul className="mt-8 grid gap-x-4 gap-y-8 sm:grid-cols-2 lg:grid-cols-3" data-id="element-20" data-mp="zureximihkx6">
          {bonuses.map(b => <li key={b.number} className="text-center" data-id="element-21" data-mp="1ejnib2dmi9rg">
              <img src={b.image} alt={`${b.title} — official BREAK FREE™ bonus cover`} className="mx-auto w-full max-w-[11rem]" width={1080} height={1350} data-id="element-22" data-mp="1el8awmgdnimo" />
              <p className="mt-3 text-[10px] font-semibold uppercase tracking-[0.22em] text-champagne" data-id="element-23" data-mp="1jji7n1hr2rae">
                {b.number}
              </p>
              <h3 className="mt-1 font-display text-base font-semibold uppercase leading-tight text-ivory-50" data-id="element-24" data-mp="3psoii9wly9o7">
                {b.title}
              </h3>
              <p className="mx-auto mt-1.5 max-w-[15rem] text-[13px] leading-snug text-body" data-id="element-25" data-mp="2kujwk02pv7y">
                {b.line}
              </p>
              <p className="mt-2 text-[10px] font-semibold uppercase tracking-[0.16em]" data-id="element-26" data-mp="7icj3ioagw2r">
                <span className="text-muted line-through" data-id="element-27" data-mp="chphn0oivrl6">{b.value}</span>
                <span className="ml-2 text-champagne" data-id="element-28" data-mp="gk2jvf4297d7">Free</span>
              </p>
            </li>)}
        </ul>

        <p className="mt-10 border-y border-champagne/25 py-5 text-center text-[13px] font-semibold uppercase tracking-[0.18em] text-ivory-100" data-id="element-29" data-mp="le6uc8cjbxj1">
          Total bonus value <span className="text-muted line-through" data-id="element-30" data-mp="vbcjhb1l9egm">$392</span>
          <span className="ml-3 text-champagne" data-id="element-31" data-mp="1094nh3ficr16">→ Included free</span>
        </p>
      </div>
    </section>;
}